export default __webpack_public_path__ + "static/media/icon_g2.7535bbe6.svg";